



























import { Component, Vue } from 'vue-property-decorator'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import StoreRelatorios from '@/store/Relatorios'

@Component

export default class ViewRelatorioFontePagadora extends Vue {
  relatorio: Object = {}
  idFontePagadora: String = ''

  data() {
    return {
      relatorio: {},
      idFontePagadora: this.$route.params.idFontePagadora,
      dataInicial: this.$route.params.dataInicial,
      dataFinal: this.$route.params.dataFinal,
    }
  }

  get prestador(): any {
    return StoreRelatorios.getters.PRESTADOR
  }

  mounted() {
    this.getRelatorio()
  }

  back() {
    this.$router.go(-1)
  }

  async getRelatorio() {
    let prestadorId = null

    const hasPrestador = Object.keys(this.prestador).length > 0
    if (hasPrestador) prestadorId = this.prestador.id

    const relatorio = await
    ApiLegacy.Reports.getRecebimentoOld(this.idFontePagadora, 6, prestadorId)
    this.relatorio = relatorio.data.data
  }
}
